import { Component, OnInit } from "@angular/core"
import { Modalable } from "@app/Modalable"

@Component({
	selector: "app-change-password",
	template: `
		<div style="max-width:200px;">
			<div
				class="form-group"
				style="margin-top:20px;"
			>
				<label>{{ "password_new" | langVal }}</label>
				<app-gen-input
					[actualObj]="actObject"
					fieldName="password"
					type="password"
					[errors]="errors"
					(keyupEvent)="validateEntireForm()"
				>
				</app-gen-input>
			</div>
			<div class="form-group">
				<label>{{ "password_new_confirmation" | langVal }}</label>
				<app-gen-input
					[actualObj]="actObject"
					fieldName="password_confirmation"
					type="password"
					[errors]="errors"
					title_ph_lang="confirm_password"
					(keyupEvent)="validateEntireForm()"
				/>
			</div>
		</div>

		<div class="modal-btns">
			@if (isModalMode) {
				<app-cancel-btn (click)="close()" />
			}
			<app-btn-ext
				text="change_password"
				[disabled]="!isFormSubmittable"
				(clickEv)="submit()"
				[isSpin]="isSaving"
			/>
		</div>
	`,
})
export class ChangePasswordComponent extends Modalable {
	modalTitleLang: string = "change_password"
	modalWidth: string = "modal-narrow-width"
	showPassword: boolean = false
	actObject: any = { password: "", password_confirmation: "" } //the object that holds the field values (and is saved)
	isFormSubmittable: boolean = false //can submit (controls disabled in the submit button)
	isSaving: boolean = false //while waiting for the api to return from saving (controls save btn disabled and outputs a "waiting" gif)
	errors: any = {} //will hold errors for the fields in the form
	validationFields: any = {
		//field validations, control displaying field errors and ability to submit the form
		password: {
			not_empty: null,
			str_min: 8,
			str_max: 16,
			regex_password: null,
		},
		password_confirmation: { not_empty: null, identicalToPassword: null },
	}

	validateEntireForm() {
		//validate all fields and detrmine if can be submitted (or has errors)
		this.isFormSubmittable = this.validator.validateEntireForm(
			this.actObject,
			this.errors,
			this.validationFields
		)
	}

	async submit() {
		//submit this form to the api
		if (!this.isFormSubmittable) {
			return
		} //has errors - exit
		if (this.isSaving) {
			return
		} //is curently waiting for api to finish saving - exit
		this.isSaving = true //flag "waiting for the api to finish saving" as true

		const res: any = await this.apiService.post(
			"change_password",
			this.actObject
		)
		this.isSaving = false //flag "waiting for the api to finish saving" as false
		let mes = res.success
			? this.lang.getVal("password_was_changed")
			: this.lang.getVal(res?.message) //message of success or error from server
		if (res.success) {
			//if save success - close this modal
			this.close()
		}
		this.modalService.openToast(mes) //toast the message
	}
}
